interface SystemMessageProps {
  content: string;
  createdAt: string;
}

export function SystemMessage({ content, createdAt }: SystemMessageProps) {
  return (
    <div className="flex justify-center py-2">
      <div className="bg-muted/50 text-muted-foreground text-xs px-3 py-1.5 rounded-full text-center max-w-[80%]">
        {content}
      </div>
    </div>
  );
}
